import PropTypes from "prop-types";
import {
  dateFmt,
  formatRelativeDate,
  parseEventTime,
  timeTzFmt,
} from "../../../../util/formatDate.js";
import s from "./EventRow.module.css";
import * as Icons from "./Icons.jsx";
import { offCameraDates } from "./offCameraDates.js";

function buildEventUrl(event) {
  if (!event?.event_url) return null;
  return event.event_url.startsWith("http")
    ? event.event_url
    : `https://${event.event_url}`;
}
export default function EventRow({ event, variant }) {
  const date = parseEventTime(event);
  if (!date) return null;

  const url = buildEventUrl(event);
  const relative = formatRelativeDate(date);
  const isLive = variant === "live";

  const dateStr = isLive ? dateFmt.format(date) : null;
  const timeStr = isLive && event.has_time ? timeTzFmt.format(date) : null;
  const offCamera = isLive ? null : offCameraDates(event);

  const content = (
    <>
      {isLive ? (
        <img
          className={s.leadingAvatar}
          src={event.influencer_avatar_url}
          alt=""
        />
      ) : (
        <div className={s.leadingBadge} aria-hidden="true">
          <span className={s.month}>{offCamera.month}</span>
          <span className={s.day}>{offCamera.day}</span>
        </div>
      )}

      <div className={s.rowInfo}>
        <div className={s.rowTitleLine}>
          <span className={s.rowTitle}>
            {event.event_title || "Signing session"}
          </span>
          {relative && <span className={s.rowRelative}>{relative}</span>}
        </div>

        <div className={s.rowMeta}>
          {isLive ? (
            <>
              <span>
                <Icons.CalendarIcon /> {dateStr}
              </span>
              {timeStr && (
                <span>
                  <Icons.ClockIcon /> {timeStr}
                </span>
              )}
              {event.influencer_name && <span>{event.influencer_name}</span>}
              {event.platform && <span>on {event.platform}</span>}
            </>
          ) : (
            <>
              <time dateTime={offCamera.dateTime}>{offCamera.text}</time>
              {event.influencer_name && <span>{event.influencer_name}</span>}
            </>
          )}
        </div>

        {event.event_description && (
          <p className={s.rowDescription}>{event.event_description}</p>
        )}
      </div>

      {isLive && url && (
        <span className={s.rowLink} aria-hidden="true">
          View →
        </span>
      )}
    </>
  );

  if (url) {
    return (
      <li>
        <a
          className={`${s.row} ${s.rowClickable}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {content}
        </a>
      </li>
    );
  }

  return <li className={s.row}>{content}</li>;
}

EventRow.propTypes = {
  event: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(["live", "offcamera"]).isRequired,
};
